import React from "react";
import Spinner from "@src/components/atoms/spinner/spinner";
import styles from "./dashboard-panel.module.scss";

const cssClassName = "dashboard-panel";

export const SpinnerWrapper = () => {
  return (
    <div className={styles[`${cssClassName}__spinner-wrapper`]}>
      <Spinner />
    </div>
  );
};
